import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { UploadGoalsMediaResponseData } from "schema"
import { z } from "zod"

type Response = { data: z.infer<typeof UploadGoalsMediaResponseData> }

export const useUploadGoalMediaMutation = () => {
  return useMutation({
    mutationFn: async (file: FileList) => {
      const { data } = await axios.post<Response>(`/goals/media`, {
        file,
      })
      return data.data
    },
  })
}
